export const servicesSnapshot = [
  {
    id: "homemaker",
    title: "Homemaker Services",
    description: "Housecleaning, laundry, meal preparation, errands, companionship, and other allied needs in the comfort of your home.",
    icon: "ri-home-smile-line",
  },
  {
    id: "companion",
    title: "Home Care Companion",
    description: "Light housekeeping, meal preparation, transportation, companionship, and emotional support.",
    icon: "ri-chat-heart-line",
  },
  {
    id: "personal-care",
    title: "Personal Care Attendant",
    description: "Assistance with bathing, dressing, grooming, mobility, feeding, toileting, and activities of daily living.",
    icon: "ri-user-heart-line",
  },
  {
    id: "dementia-parkinsons",
    title: "Dementia & Parkinson's Support",
    description: "Specialized activities promoting balance, coordination, speech, and movement with familiar routines.",
    icon: "ri-brain-line",
  },
  {
    id: "private-duty",
    title: "Private Duty",
    description: "Dedicated one-on-one care tailored to your specific needs and schedule with a consistent caregiver.",
    icon: "ri-user-star-line",
  },
  {
    id: "hospices",
    title: "Hospices",
    description: "Specialized comfort and support services for individuals facing terminal illness or end-of-life situations, providing peace for patients and families.",
    icon: "ri-heart-pulse-line",
  },
];

export const whyChooseUs = [
  {
    title: "Compassionate Care",
    description: "Our caregivers are chosen for their empathy and dedication to treating every client like family.",
    icon: "ri-heart-3-line",
  },
  {
    title: "Professional Caregivers",
    description: "Fully screened, trained, and certified professionals with ongoing education and supervision.",
    icon: "ri-shield-check-line",
  },
  {
    title: "Personalized Care Plans",
    description: "Every client receives a custom care plan designed around their unique needs, preferences, and goals.",
    icon: "ri-file-list-3-line",
  },
  {
    title: "24 Hours On-call",
    description: "Round-the-clock support and emergency response so you are never alone when it matters most.",
    icon: "ri-24-hours-line",
  },
  {
    title: "Serving Illinois Counties",
    description: "We proudly serve Cook, Kane, Will, DuPage, Kendall, and LaSalle counties across Illinois.",
    icon: "ri-map-2-line",
  },
];

export const testimonials = [
  {
    id: 1,
    name: "Margaret T.",
    location: "Naperville, IL",
    rating: 5,
    text: "Sycamore Oasis changed our lives. The caregivers are kind, patient, and truly care about my mother's wellbeing. I finally have peace of mind.",
    image: "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20smiling%20senior%20woman%20in%20her%2070s%20with%20short%20gray%20hair%2C%20warm%20and%20friendly%20expression%2C%20soft%20natural%20lighting%2C%20neutral%20warm%20background%2C%20professional%20headshot%20style&width=120&height=120&seq=t1&orientation=squarish",
  },
  {
    id: 2,
    name: "Robert H.",
    location: "Aurora, IL",
    rating: 5,
    text: "After my surgery, I needed help at home. The team was professional, punctual, and went above and beyond. Highly recommended!",
    image: "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20friendly%20senior%20man%20in%20his%2070s%20with%20glasses%20and%20short%20gray%20hair%2C%20warm%20smile%2C%20soft%20natural%20lighting%2C%20neutral%20warm%20background%2C%20professional%20headshot%20style&width=120&height=120&seq=t2&orientation=squarish",
  },
  {
    id: 3,
    name: "The Johnson Family",
    location: "Wheaton, IL",
    rating: 5,
    text: "We searched for months before finding Sycamore Oasis. Their personalized approach and attention to detail set them apart from every other agency.",
    image: "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20warm%20middle-aged%20woman%20in%20her%2050s%20with%20shoulder-length%20brown%20hair%2C%20kind%20expression%2C%20soft%20natural%20lighting%2C%20neutral%20warm%20background%2C%20professional%20headshot%20style&width=120&height=120&seq=t3&orientation=squarish",
  },
];

export const coverageCounties = [
  "Cook",
  "Kane",
  "Will",
  "DuPage",
  "Kendall",
  "LaSalle",
];